import type { SearchParamsRecord } from '../queryParams';
import { Effect, Exit, Schema } from 'effect';

export const PageSchema = Schema.FiniteFromString.check(Schema.isInt(), Schema.isGreaterThan(0));

export const ItemsPerPageSchema = Schema.FiniteFromString.check(
  Schema.isInt(),
  Schema.isGreaterThan(0)
);

export const PaginationSchema = (itemsPerPageDefault: number) =>
  Schema.Struct({
    page: PageSchema.pipe(Schema.withDecodingDefaultType(Effect.succeed(1))),
    itemsPerPage: ItemsPerPageSchema.pipe(
      Schema.withDecodingDefaultType(Effect.succeed(itemsPerPageDefault))
    ),
  });

/**
 * @see parseUrlForSSR
 */
export const decodePaginationSearchParams = (
  searchParams: SearchParamsRecord,
  itemsPerPage: number
) => {
  const PaginationSchemaWithDefaults = PaginationSchema(itemsPerPage);
  const decodeQueryParams = Schema.decodeUnknownExit(PaginationSchemaWithDefaults);

  const paginationResult = decodeQueryParams(searchParams);

  // v4: `Schema.decodeUnknownExit` returns `Exit` (not Result). Fall back via
  // `Exit.match` when the decode fails.
  return Exit.match(paginationResult, {
    onFailure: () => PaginationSchemaWithDefaults.make({ page: 1, itemsPerPage }),
    onSuccess: (value) => value,
  });
};
